import { useMutation, useQueryClient } from "@tanstack/react-query";
import { http } from "../../utils";

async function addFullShipping(formData) {
  const data = await http(`/admin/product-deliveries`, {
    data: formData,
  });
  return data;
}

export function useAddFullShipping() {
  const queryClient = useQueryClient();

  return useMutation(addFullShipping, {
    onSuccess: () => {
      queryClient.refetchQueries(["product-deliveries"]);
      queryClient.refetchQueries(["product-order-parents"]);
    },
  });
}
